import { publicAxios } from "@/api/public.js";

class API {
  static getToken(payload) {
    return publicAxios.post("/connect/token", payload, {
      withCredentials: true,
      headers: {
        'AreaUsuario': "agronegocio"
      }
    });
  }

  static getGuestToken(payload) {
    return publicAxios.post("/connect/guestToken", payload, {
      withCredentials: true,
      headers: {
        'AreaUsuario': "agronegocio"
      }
    });
  }

  static putForgotPassword(payload) {
    return publicAxios.put("/v1/usuarios/esqueci-senha/", payload, {
      withCredentials: true,
      headers: {
        'AreaUsuario': "agronegocio"
      }
    });  }

  static putRecoverPassword(payload) {
    return publicAxios.put("/v1/usuarios/recuperar-senha/", payload, {
      withCredentials: true,
      headers: {
        'AreaUsuario': "agronegocio"
      }
    });
  }
}

export default API;
